import { restrictions as config } from '@config';

const BaseView = require('./abstract-type');
const template = require('./text-type.hbs');

module.exports = BaseView.extend({
  type: 'text',
  basicHide: ['text_add', 'text_change_content', 'text_colour', 'color', 'highlightcolor', 'text_z_index','text_column'],
  storedDateFormat: 'MM/DD/YY',
  events: {
    'change input[name="list"]': 'resizeListEvent',
    'keydown .restrictions.group[data-name="character_number"] input': 'toggleRestrictionEvent',
    'keydown .restrictions.group[data-name="numeric"] input': 'toggleRestrictionEvent',
    'keydown .restrictions.group[data-name="currencies"] input': 'toggleRestrictionEvent',
    'click .typeahead': 'changeFormatEvent',
    'change input[name="dateformat"]': 'changeFormatEvent',
    'apply.daterangepicker input[name="daterange"]': 'selectDateRangeEvent',
    'show.daterangepicker input[name="daterange"]': 'showDateRangeEvent',
    ...BaseView.prototype.events
  },

  toggleSectionEvent: function (event) {
    const option = event.currentTarget;
    const sectionName = option.closest('.restrictions.group').getAttribute('data-name') || 'basic';
    const name = option.getAttribute('name') || option.closest('.restrictions.group[data-field]')?.getAttribute('data-field');
    const value = this.getOptionValue($(option));
    const radioButtonsAction = () => {
      const radioButtons = document.querySelectorAll('div[data-radiogroup="content-restriction"]');
      const replacement = this.el.querySelector(`div.${sectionName}-replacement-options`);

      for (const radioButton of radioButtons) {
        const name = radioButton.getAttribute('data-name');
        (name === sectionName && replacement)
          ? replacement.classList.toggle('hidden', !value)
          : this.el.querySelector(`div.${name}-replacement-options`)?.classList.toggle('hidden', true);
      }

      if (value) {
        if (sectionName === 'date') this.selectDateRangeEvent();

        const min = replacement?.querySelector('input[name="min"]');
        const max = replacement?.querySelector('input[name="max"]');
        min && !min.value && (min.value = 0);
        max && !max.value && (max.value = 0);
        $(min).trigger('change');
        $(max).trigger('change');
      }
    };

    option.checked && this._addDefaultList(option);
    this._toggleSectionDisabled(option);

    if (option.id === 'element-restrictions-any') {
      const replateTextToggleList = document.querySelector('ul[name="text_change_content-toggle-suboptions"]');
      replateTextToggleList.classList.toggle('hidden', !option.checked);
      const checkedRadio = replateTextToggleList.querySelector('input[type="radio"]:checked');

      if (checkedRadio) {
        checkedRadio.checked = false;
        radioButtonsAction();
        this.persistOptionRestriction($(checkedRadio));
      }
    } else if (name === 'text_change_content-suboptions') {
      if (option.id === 'text_change_content') {
        const replaceAnyTextToggle = document.querySelector(
          'ul[name="text_change_content-suboptions"] #element-restrictions-any');

        replaceAnyTextToggle.checked = false;
      }

      radioButtonsAction();
    }

    this.recalculateSectionHeight(option);
    BaseView.prototype.toggleSectionEvent.apply(this, arguments);
  },

  _toggleSectionDisabled: function (option) {
    const sectionName = option.closest('.restrictions.group').getAttribute('data-name') || 'basic';
    const name = option.getAttribute('name') || option.closest('.restrictions.group[data-field]')?.getAttribute('data-field');
    const value = this.getOptionValue($(option));

    sectionName === 'basic'
      ? this._toggleBasicSectionDisabled(name, value)
      : this._toggleColorsSectionDisabled(sectionName, value);
  },

  _deselectTextChangeContentSubOptions: function (textChangeContentSubOptions) {
    textChangeContentSubOptions
      .querySelectorAll(
        'input[type="radio"][name="text_change_content-suboptions"]'
      )
      .forEach((input) => (input.checked = false));

    textChangeContentSubOptions
      .querySelectorAll(
        '.replacement-options'
      )
      .forEach((element) => (element.classList.toggle('hidden', true)));
  },

  _toggleBasicSectionDisabled: function (name, value) {
    if (name === 'text_change_content' || name === 'text_change_content-suboptions') {
      const textChangeContentToggleSubOptions = this.el.querySelector('ul[name="text_change_content-toggle-suboptions"]');
      const textChangeContentSubOptions = this.el.querySelector('ul[name="text_change_content-suboptions"]');

      name === 'text_change_content' && textChangeContentSubOptions.classList.toggle('hidden', !value);

      if (!value) {
        textChangeContentToggleSubOptions.classList.add('hidden');
        this.el.querySelector('ul[name="text_change_content-suboptions"] #element-restrictions-any').checked = false;
      }

      this._deselectTextChangeContentSubOptions(textChangeContentToggleSubOptions);
      this._deselectTextChangeContentSubOptions(textChangeContentSubOptions);
    } else if (name === 'color' || name === 'text_highlight') {
      const colorType = name === 'color' ? '' : 'highlight';

      this.el.querySelector(`div[data-name="${colorType}colors"] .element-restriction-sub-options`).parentNode.classList.toggle('hidden', !value);
      this.el.querySelector(`div[data-name="${colorType}colors-library"] .element-restriction-sub-options`).parentNode.classList.toggle('hidden', !value);

      if (value) return;

      const colors = this.el.querySelector(`#element-restrictions${colorType && '-' + colorType}-colors`);
      const colorsLibrary = this.el.querySelector(`#element-restrictions${colorType && '-' + colorType}-colors-library`);
      this.el.querySelector(`.${colorType}colors-replacement-options`).classList.toggle('hidden', true);
      this.el.querySelector(`.${colorType}colors-library-replacement-options`).classList.toggle('hidden', true);

      const previousColorsChecked = colors.checked;
      const previousColorsLibraryChecked = colorsLibrary.checked;

      colors.checked = false;
      colorsLibrary.checked = false;
      previousColorsChecked && this.onSectionChange(colors);
      previousColorsLibraryChecked && this.onSectionChange(colorsLibrary);
      name === 'color' ? this.colorsLibraryView.removeAllElement() : this.highlightcolorsListView.removeAllElement();
    }
  },

  _toggleColorsSectionDisabled: function (sectionName, value) {
    switch (sectionName) {
      case 'colors':
        this.el.querySelector('.colors-replacement-options').classList.toggle('hidden', !value);
        !value && this.colorsListView.removeAllElement();
        break;
      case 'colors-library':
        this.el.querySelector('.colors-library-replacement-options').classList.toggle('hidden', !value);
        break;
      case 'highlightcolors':
        this.el.querySelector('.highlightcolors-replacement-options').classList.toggle('hidden', !value);
        !value && this.colorsListView.removeAllElement();
        break;
      case 'highlightcolors-library':
        this.el.querySelector('.highlightcolors-library-replacement-options').classList.toggle('hidden', !value);
        break;
      default:
        break;
    }
  },

  _addDefaultList: function (option) {
    if (option.id === 'element-restrictions-colors-content') {
      const colors = this.el.querySelector('#element-restrictions-colors');
      const colorsLibrary = this.el.querySelector('#element-restrictions-colors-library');

      colors.checked = false;
      colorsLibrary.checked = false;
      this._toggleSectionDisabled(colors);
      this._toggleSectionDisabled(colorsLibrary);
      this.onSectionChange(colors);
      this.onSectionChange(colorsLibrary);
    }

    if (option.id === 'element-restrictions-colors' && !this.colorsListView.getData().length) {
      const colorsLibrary = this.el.querySelector('#element-restrictions-colors-library');

      this.colorsListView.getData().length || this.colorsListView.addElement(this.selection.color);

      if (colorsLibrary.checked) {
        colorsLibrary.checked = false;
        this._toggleSectionDisabled(colorsLibrary);
        this.onSectionChange(colorsLibrary);
      }
    }

    if (option.id === 'element-restrictions-colors-library') {
      const colors = this.el.querySelector('#element-restrictions-colors');

      this.colorsLibraryView.setLibraryPaletteRestriction({ palette: 0 });
      if (colors.checked) {
        colors.checked = false;
        this._toggleSectionDisabled(colors);
        this.onSectionChange(colors);
      }
    }

    if (option.id === 'element-restrictions-highlight-colors') {
      const hightColorsLibrary = this.el.querySelector('#element-restrictions-highlight-colors-library');

      this.highlightcolorsListView.getData().length ||
      this.highlightcolorsListView.addElement(this.selection.color);
      hightColorsLibrary.checked = false;
      this._toggleSectionDisabled(hightColorsLibrary);
      this.onSectionChange(hightColorsLibrary);
    }

    if (option.id === 'element-restrictions-highlight-colors-library') {
      const hightColors = this.el.querySelector('#element-restrictions-highlight-colors');

      this.highlightcolorsLibraryView.setLibraryPaletteRestriction({ palette: 0 });
      hightColors.checked = false;
      this._toggleSectionDisabled(hightColors);
      this.onSectionChange(hightColors);
    }

    if (option.id === 'element-restriction-text_highlight') {
      const hightColors = this.el.querySelector('#element-restrictions-highlight-colors');
      const hightColorsLibrary = this.el.querySelector('#element-restrictions-highlight-colors-library');

      hightColors.checked = false;
      hightColorsLibrary.checked = false;
      this._toggleSectionDisabled(hightColors);
      this.onSectionChange(hightColors);
      this._toggleSectionDisabled(hightColorsLibrary);
      this.onSectionChange(hightColorsLibrary);
    }
  },

  changeFormatEvent: function (event) {
    const hoveredOption = event.currentTarget.parentNode.querySelector('ul.typeahead li:hover');
    hoveredOption && hoveredOption.click();
    this.applyDateFormat();
  },

  selectDateRangeEvent: function () {
    this.applyDateFormat().trigger('change');
  },

  showDateRangeEvent: function () {
    const picker = this.el.querySelector('.daterangepicker');
    picker.style.display = 'flex';
  },

  _renderCalendarButton: function () {
    const prevMonth = this.el.querySelector('.daterangepicker .calendar.left .prev.available');
    const nextMonth = this.el.querySelector('.daterangepicker .calendar.left th:last-of-type');
    const classNames = ['next', 'available'];

    if (!nextMonth || classNames.some(className => nextMonth.classList.contains(className))) return;

    const oldIcon = prevMonth.querySelector('i');
    const newIcon = prevMonth.querySelector('icon');
    oldIcon && oldIcon.remove();
    newIcon || (prevMonth.innerHTML = '<icon><svg><use href="#editor-chevron-right"/></svg></icon>');

    nextMonth.classList.add('next', 'available');
    nextMonth.innerHTML = '<icon><svg><use href="#editor-chevron-right"/></svg></icon>';
  },

  applyDateFormat: function () {
    const dateFormatInput = this.el.querySelector('input[name="dateformat"]');
    const dateRangeInput = this.el.querySelector('input[name="daterange"]');

    const format = dateFormatInput.value || this.storedDateFormat;
    const picker = $(dateRangeInput).data('daterangepicker');
    const end = picker.endDate.format(format);
    const start = picker.startDate.format(format);

    picker.locale.format = format;
    dateRangeInput.value = `${start} ~ ${end}`;

    return $(dateRangeInput);
  },

  resizeListEvent: function (event) {
    this.recalculateSectionHeight(event.currentTarget);
  },

  render: async function () {
    const someGroup = _(this.groups).find(function (group) {
      return group.permissions && group.permissions.template;
    });

    if (!someGroup) return;

    const basicPermissions = _.chain(someGroup.permissions.template)
      .map(function (value, index) {
        return {
          name: index,
          tag: 'tool.restrictions.template.permission.' + index
        };
      })
      .filter(function (field) {
        return this.basicHide.indexOf(field.name) < 0;
      }, this)
      .filter(function (field) {
        return field.name.match(/^text_/);
      }).value();

    const excludedRestrictions = ['text_font_family', 'text_spacing', 'text_alignment', 'text_highlight', 'text_size',
      'text_opacity', 'text_font_size', 'text_decoration', 'text_z_index'];
    this.$el.html(template({
      basic: this.sortElementPermissions('text', basicPermissions).filter((p) => !excludedRestrictions.includes(p.name)),
      swearing: config.swearingFilters
    }));

    await this.initLibraryFolders(this.type);
    this.initDictionary();
    this.initDateFormat();
    this.initDateRange();
    this.initColorsList();
    this.initLibraryColors();
    this.initColorsList('highlight');
    this.initLibraryColors('highlight');
    this.renderRestrictions();
    this.setMinMaxFieldValues();
    this.renderDisabled();
  },

  renderDisabled: function () {
    this._renderTextContentDisabled();
    this._renderColorDisabled();
    this._renderTextHighlightDisabled();
  },

  _renderTextContentDisabled: function () {
    const replaceTextInput = document.querySelector('#element-restrictions-text-content');
    const replaceAnyTextToggle = document.querySelector('ul[name="text_change_content-suboptions"] #element-restrictions-any');
    const replaceTextList = document.querySelector('ul[name="text_change_content-suboptions"]');
    const replateTextToggleList = document.querySelector('ul[name="text_change_content-toggle-suboptions"]');
    const radioButtons = document.querySelectorAll('div[data-radiogroup="content-restriction"]');
    const isReplaceOn = this.getOptionValue($(replaceTextInput));
    const isReplaceToggleOn = this.getOptionValue($(replaceAnyTextToggle));

    replaceTextInput && replaceTextList.classList.toggle('hidden', !isReplaceOn);
    replateTextToggleList && replateTextToggleList.classList.toggle('hidden', !isReplaceToggleOn || !isReplaceOn);

    for (const radioButton of radioButtons) {
      const name = radioButton.getAttribute('data-name');
      const input = radioButton.querySelector(
        `label.switch input[type="${name === 'swearing' ? 'checkbox' : 'radio'}"]`);
      radioButton.parentNode.querySelector(`div.${name}-replacement-options`)?.classList
        .toggle('hidden', !this.getOptionValue($(input)));
    }
  },

  _renderColorDisabled: function () {
    const replaceColorInput = document.querySelector('#element-restrictions-color-content');
    const replaceColorSubInput = document.querySelector('#element-restrictions-colors');
    const replaceColorPaletteSubInput = document.querySelector('#element-restrictions-colors-library');
    const isReplaceOn = this.getOptionValue($(replaceColorInput));
    const isReplaceSpecifiedColorOn = this.getOptionValue($(replaceColorSubInput));
    const isReplaceSpecifiedPaletteOn = this.getOptionValue($(replaceColorPaletteSubInput));

    if (replaceColorInput) {
      this.el.querySelector('div[data-name="colors"] .element-restriction-sub-options').parentNode.classList.toggle('hidden', !isReplaceOn);
      this.el.querySelector('div[data-name="colors-library"] .element-restriction-sub-options').parentNode.classList.toggle('hidden', !isReplaceOn);

      if (replaceColorSubInput) {
        this.el.querySelector('.colors-replacement-options').classList.toggle('hidden', !(isReplaceOn && isReplaceSpecifiedColorOn));
      }

      if (replaceColorPaletteSubInput) {
        this.el.querySelector('.colors-library-replacement-options').classList.toggle('hidden', !(isReplaceOn && isReplaceSpecifiedPaletteOn));
      }
    }
  },

  _renderTextHighlightDisabled: function () {
    const replaceColorInput = document.querySelector('#element-restriction-text_highlight');
    const replaceColorSubInput = document.querySelector('#element-restrictions-highlight-colors');
    const replaceColorPaletteSubInput = document.querySelector('#element-restrictions-highlight-colors-library');
    const isReplaceOn = this.getOptionValue($(replaceColorInput));
    const isReplaceSpecifiedColorOn = this.getOptionValue($(replaceColorSubInput));
    const isReplaceSpecifiedPaletteOn = this.getOptionValue($(replaceColorPaletteSubInput));

    if (replaceColorInput) {
      this.el.querySelector('div[data-name="highlightcolors"] .element-restriction-sub-options').parentNode.classList.toggle('hidden', !isReplaceOn);
      this.el.querySelector('div[data-name="highlightcolors-library"] .element-restriction-sub-options').parentNode.classList.toggle('hidden', !isReplaceOn);

      if (replaceColorSubInput) {
        this.el.querySelector('.highlightcolors-replacement-options').classList.toggle('hidden', !(isReplaceOn && isReplaceSpecifiedColorOn));
      }

      if (replaceColorPaletteSubInput) {
        this.el.querySelector('.highlightcolors-library-replacement-options').classList.toggle('hidden', !(isReplaceOn && isReplaceSpecifiedPaletteOn));
      }
      this.recalculateSectionHeight(replaceColorInput);
    }
  },

  initDictionary: function () {
    const $wordList = this.$el.find('input[name="list"]');

    $wordList.tagsinput({
      confirmKeys: [13, 9]
    });
    $wordList.tagsinput('input')
      .attr('tabindex', $wordList.attr('tabindex'))
      .on('keydown', function (event) {
        const tabKey = 9;

        if (event.which === tabKey) {
          const val = $(this).val();

          _.defer(_.bind(function () {
            $wordList.tagsinput('focus');
            $(this).val(val);
            $(this).trigger('keypress');
          }, this));
        }
      });

    $wordList.siblings('.bootstrap-tagsinput').find('input[type="text"]').attr('style', 'width: 258px !important');
  },

  initDateFormat: function () {
    this.$el.find('input[name="dateformat"]').typeahead({
      highlight: true,
      minLength: 0,
      source: config.dateFormat
    });
  },

  initDateRange: function () {
    const dateRange = this.el.querySelector('input[name="daterange"]');
    $(dateRange).daterangepicker({
      autoUpdateInput: false,
      parentEl: this.el
    });

    this.el.querySelector('.daterangepicker .calendar.left').classList.add('single');
    INKIVE.Helpers.registerMutationObserver(
      [this.el.querySelector('.daterangepicker .calendar.left .calendar-table')],
      this._renderCalendarButton.bind(this),
      ['DOMSubtreeModified']);
  },

  handleFolderSelected: function (folders) {
    const nonEmptyFolders = folders.filter(Boolean);
    const $hiddenInput = $(this.el.querySelector('[data-name="source"]').parentElement.querySelector('input[name="library_folder"]'));
    $hiddenInput.val(JSON.stringify(nonEmptyFolders));
    this.persistOptionRestriction($hiddenInput);
  },

  renderRestrictions: function () {
    BaseView.prototype.renderRestrictions.apply(this);
    const options = document.querySelectorAll('ul[name="text_change_content-toggle-suboptions"] input[type="radio"]');
    const isChecked = Array.from(options).some(radio => radio.checked);
    document.querySelector('ul[name="text_change_content-suboptions"] #element-restrictions-any').checked = isChecked;
  },

  _renderRestrictions: function (restrictions, sectionName) {
    if (sectionName === 'date') {
      return this.renderDateRestrictions(restrictions);
    }

    if (sectionName === 'dictionary') {
      return this.renderDictionaryRestrictions(restrictions);
    }

    if (sectionName === 'swearing') {
      return this.renderSwearingRestrictions(restrictions);
    }

    if (sectionName === 'character_number') {
      return this.renderCharacterNumberRestrictions(restrictions, sectionName);
    }

    if (sectionName === 'colors' && restrictions[sectionName]?.list?.length) {
      _(restrictions[sectionName].list).each(this.colorsListView.addElement);
    }

    if (sectionName === 'colors-library' && restrictions[sectionName]?.palette) {
      this.colorsLibraryView.setLibraryPaletteRestriction(restrictions[sectionName]);
    }

    if (sectionName === 'highlightcolors' && restrictions[sectionName]?.list?.length) {
      _(restrictions[sectionName].list).each(this.highlightcolorsListView.addElement);
    }

    if (sectionName === 'highlightcolors-library' && restrictions[sectionName]?.palette) {
      this.highlightcolorsLibraryView.setLibraryPaletteRestriction(restrictions[sectionName]);
    }

    return BaseView.prototype._renderRestrictions.apply(this, arguments);
  },

  renderSwearingRestrictions: function (restrictions) {
    if (!restrictions.swearing) return;

    const filter = restrictions.swearing;

    this.el.querySelector('.restrictions.group[data-name="swearing"] label.switch input[type="checkbox"]').checked = true;

    for (const [key, value] of Object.entries(filter)) {
      this.el.querySelector('.swearing-replacement-options .options li input[name="' + key + '"]').checked = value;
    }
  },

  renderCharacterNumberRestrictions: function (restrictions) {
    if (!restrictions.character_number) return;

    const min = restrictions.character_number && restrictions.character_number.min;
    const max = restrictions.character_number && restrictions.character_number.max;
    const group = this.el.querySelector('.restrictions.group[data-name="character_number"]');
    const minField = group.parentNode.querySelector('.replacement-options input[type="number"][name="min"]');
    const maxField = group.parentNode.querySelector('.replacement-options input[type="number"][name="max"]');
    group.querySelector('label.switch input[type="radio"]').checked = restrictions.character_number;
    minField.value = min;
    maxField.value = max;
  },

  renderDictionaryRestrictions: function (restrictions) {
    if (!restrictions.dictionary) return;

    const list = restrictions.dictionary && restrictions.dictionary.list;
    const input = this.el.querySelector('.replacement-options .options li input[name="list"]');
    this.el.querySelector('.restrictions.group[data-name="dictionary"] label.switch input[type="radio"]').checked = true;

    if (list) {
      for (const item of list) $(input).tagsinput('add', item);
    }
  },

  renderDateRestrictions: function (restrictions) {
    const r = restrictions.date;

    if (!r) return;

    const picker = this.$el.find('.replacement-options .options li input[name="daterange"]').data('daterangepicker');

    this.el.querySelector('.restrictions.group[data-name="date"] label.switch input[type="radio"]').checked = r;
    r.dateformat && (this.el.querySelector('.replacement-options .options li input[name="dateformat"]').value = r.dateformat);

    if (r.daterange) {
      picker.locale.format = this.storedDateFormat;
      picker.setStartDate(r.daterange.start);
      picker.setEndDate(r.daterange.end);
      this.applyDateFormat();
    }
  },

  toggleRestrictionEvent: function (event) {
    event.stopPropagation();
    const $option = $(event.currentTarget);
    const container = $option.closest('.group.content').addClass('disabled');

    _.debounce(() => {
      const name = $option.attr('name');

      if ($option.is('[type="number"]') && (name === 'min' || name === 'max')) {
        const $list = $option.closest('ul.options');
        const allowNegativeValues = !!$list.data('negatives-allowed');

        !allowNegativeValues && $option.val(Math.abs($option.val()));
        this.setMinMaxFieldValues($list);
      }

      event.currentTarget.id === 'element-restrictions-swearing'
        ? this.persistOptionRestriction($option.closest('.restrictions.group').children('input'))
        : BaseView.prototype.toggleRestrictionEvent.call(this, event);

      container.removeClass('disabled');
    }, 500)();
  },

  getOptionValue: function ($option) {
    if ($option.is('.element-list') && $option.data('uuid') === 'color') {
      return this.colorsListView.getData();
    }

    if ($option.is('.element-list') && $option.data('uuid') === 'highlightcolor') {
      return this.highlightcolorsListView.getData();
    }

    if ($option.is('input[name="daterange"]')) {
      return $option.val()
        ? {
            end: $option.data('daterangepicker').endDate.format(this.storedDateFormat),
            start: $option.data('daterangepicker').startDate.format(this.storedDateFormat)
          }
        : null;
    }

    if ($option.is('input[name="list"]')) {
      return $option.tagsinput('items');
    }

    if ($option.is('input[name="filter"]')) {
      return _.pluck($option.tagsinput('items'), 'id');
    }

    return BaseView.prototype.getOptionValue.apply(this, arguments);
  },

  setMinMaxFieldValues: function ($optionsList) {
    if (!$optionsList) {
      const inputGroup = document.querySelectorAll('label.switch input[type="radio"]');

      // Targeted checkboxes ids
      const targets = [
        'element-restrictions-character_number',
        'element-restrictions-numeric',
        'element-restrictions-currencies'
      ];

      inputGroup.forEach(element => {
        if (targets.includes(element.id) && element.checked) {
          const minField = element.closest('li').querySelector('.replacement-options .options li input[name="min"]');
          const maxField = element.closest('li').querySelector('.replacement-options .options li input[name="max"]');

          if (Number(maxField.value) <= Number(minField.value)) {
            maxField.value = minField.value;
            maxField.setAttribute('min', minField.value || 0);
            minField.setAttribute('min', minField.value || 0);
          }
        }
      });
    } else {
      const min = $optionsList.find('input[name="min"]')[0];
      const max = $optionsList.find('input[name="max"]')[0];
      const minValue = parseFloat(min.value);
      const maxValue = parseFloat(max.value);

      if (minValue > maxValue) max.value = minValue;
      if (minValue < maxValue) this.persistOptionRestriction($(max));

      if (minValue) max.setAttribute('min', minValue || '');
    }
  }
});
